import React, { Component } from 'react';
import Logo from '../logo';
import Search from './Search';
import ToggleLayout1 from './ToggleLayout1';
import ToggleLayout2 from './ToggleLayout2';
import ToggleRightSidebar from './ToggleRightSidebar';
import DropdownGrid from './DropdownGrid';
import DropdownTasks from './DropdownTasks';
import DropdownMessages from './DropdownMessages';
import DropdownUser from './DropdownUser';
import DropdownFlags from './DropdownFlags';
import '../../css/elements/navbar-1.css';

class Navbar1 extends Component {
  render() {
    return (
      <nav className="navbar navbar-1 d-flex justify-content-around align-items-center flex-nowrap">
        <Logo />
        <ToggleLayout1 />
        <div className="separator" />
        <ToggleRightSidebar />
        <ToggleLayout2 />
      </nav>
    );
  }
};

export default Navbar1;



// WEBPACK FOOTER //
// ./src/elements/navbar-1/Navbar1.js